export const DEFAULT_RESOURCE_ICON_BY_KIND = {
  equipment: 'i-lucide-package',
  person: 'i-lucide-user',
  role: 'i-lucide-briefcase',
};

export const resourceDisplayIcon = (resource, kindFallback = 'equipment') => {
  if (resource?.display_icon) return resource.display_icon;
  if (resource?.icon) return resource.icon;
  return (
    DEFAULT_RESOURCE_ICON_BY_KIND[resource?.kind || kindFallback] ||
    'i-lucide-package'
  );
};
